import React from 'react';
import { Input, Button } from 'antd';
import moment from 'moment';

const TimeInput = ({ 
  value, 
  onChange, 
  disabled = false, 
  placeholder = "Type time: 14:30, 1430, 2:15, or 9 (becomes 09:00)",
  showNowButton = true,
  className = "",
  style = {}
}) => {
  
  const handleBlur = (e) => {
    // Auto-format time input
    let formattedValue = e.target.value.replace(/[^\d:]/g, '');
    
    if (!formattedValue) return; // Don't format empty values
    
    if (formattedValue.length === 4 && !formattedValue.includes(':')) {
      // Convert HHMM to HH:MM
      formattedValue = formattedValue.substring(0, 2) + ':' + formattedValue.substring(2);
    }
    if (formattedValue.length === 3 && formattedValue.indexOf(':') === 1) {
      // Convert H:MM to HH:MM
      formattedValue = '0' + formattedValue;
    }
    if (formattedValue.length === 2 && /^\d{2}$/.test(formattedValue)) {
      // Convert HH to HH:00
      formattedValue = formattedValue + ':00';
    }
    if (formattedValue.length === 1 && /^\d$/.test(formattedValue)) {
      // Convert H to HH:00
      formattedValue = '0' + formattedValue + ':00';
    }
    
    // Validate the final format
    if (formattedValue.match(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/)) {
      // Update form field if value changed and is valid
      if (formattedValue !== e.target.value) {
        onChange && onChange(formattedValue);
        e.target.value = formattedValue; // Update the input display immediately
      }
    }
  };

  const handleKeyPress = (e) => {
    // Allow only digits and colon
    if (!/[\d:]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
      e.preventDefault();
    }
  };

  const handleNowClick = () => {
    const now = moment().format('HH:mm');
    onChange && onChange(now);
  };

  return (
    <Input
      value={value || ''}
      onChange={(e) => onChange && onChange(e.target.value)}
      disabled={disabled}
      placeholder={placeholder}
      className={className}
      style={{ ...style, width: '100%' }}
      maxLength={5}
      suffix={
        showNowButton && !disabled ? (
          <Button
            type="link"
            size="small"
            onClick={handleNowClick}
            style={{ padding: '0 4px', fontSize: '12px', height: 'auto' }}
          >
            Now
          </Button>
        ) : null
      }
      onBlur={handleBlur}
      onKeyPress={handleKeyPress}
    />
  );
};

export default TimeInput; 